var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9998 21.0833C5.43097 21.0833 0.916504 16.5689 0.916504 11C0.916504 5.43113 5.43097 0.916672 10.9998 0.916672C16.5687 0.916672 21.0832 5.43113 21.0832 11C21.0832 16.5689 16.5687 21.0833 10.9998 21.0833ZM10.9998 19.25C15.5562 19.25 19.2498 15.5564 19.2498 11C19.2498 6.44366 15.5562 2.75001 10.9998 2.75001C6.44349 2.75001 2.74984 6.44366 2.74984 11C2.74984 15.5564 6.44349 19.25 10.9998 19.25ZM10.9998 4.58334V6.41667C13.5311 6.41667 15.5832 8.4687 15.5832 11H17.4165C17.4165 7.45618 14.5437 4.58334 10.9998 4.58334ZM10.9998 13.75C9.48105 13.75 8.24984 12.5188 8.24984 11C8.24984 9.48122 9.48105 8.25001 10.9998 8.25001C12.5186 8.25001 13.7498 9.48122 13.7498 11C13.7498 12.5188 12.5186 13.75 10.9998 13.75ZM11.9165 11C11.9165 11.5063 11.5061 11.9167 10.9998 11.9167C10.4936 11.9167 10.0832 11.5063 10.0832 11C10.0832 10.4937 10.4936 10.0833 10.9998 10.0833C11.5061 10.0833 11.9165 10.4937 11.9165 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.1cbcef8e.svg";
export { ForwardRef as ReactComponent };